import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface AddToWishlistResponse extends APIResponse
{
}

export class AddToWishlistResponseDtoImpl extends APIResponseDtoImpl implements AddToWishlistResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/addtowishlist/addtowishlistresponse.tsx